import React, { useState, useEffect, useRef } from 'react';


const ValuesDropdown = ({ onChange }) => {
  const [message, setMessage] = useState('Updated Successfully');
  const [formValuesData, setFormValuesData] = useState(null);
  const [openCategoryIndex, setOpenCategoryIndex] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const [formValuesOption, setFormValuesOption] = useState(null);
  const [valueDependency, setValuesDependency] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setOpenCategoryIndex(null);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  useEffect(() => {
    // dispatch(showLoader());
    // getValuesDropdown()
    //   .then(function (response) {
    //     if (response?.result) {
    //       const result = response?.result;
    //       console.log('get values dropdown', result);
    //       setFormValuesData(result);
    //     }
    //     dispatch(hideLoader());
    //   })
    //   .catch((err) => {
    //     console.error.bind('get values dropdown  error', err);
    //     dispatch(hideLoader());
    //   });"
    setFormValuesData([{ "Display Name": "username" }]);
  }, []);

  const transformData = (data) => {
    return (data || []).map((item) => {
      const fieldName = item['Display Name'];
      return { label: fieldName, value: `{${fieldName}}` };
    });
  };

  useEffect(() => {
    if (formValuesData && formValuesData.length > 0) {
      console.log('form values data', formValuesData);
      const transformedData = transformData(formValuesData);
      console.log('Formatted Dropdown Data', transformedData);
      setFormValues(transformedData); // Set array, not stringified data
    }
  }, [formValuesData]);

  // Toggle sub-options on category click
  const toggleSubOptions = (index) => {
    setOpenCategoryIndex(openCategoryIndex === index ? null : index);
  };

  const handleChangeValues = (value) => {
    const selectedValue = value;

    setFormValuesOption(selectedValue);
    setValuesDependency(valueDependency + 1);
    // Call the onChange function passed from the parent
    if (onChange) {
      onChange(value);
    }
    setIsOpen(false);
    setOpenCategoryIndex(null);
  };

  return (
    <div className="col-md-3 value_block value_email_block">
      <div className="form-group value_email">
        <label>Values</label>
        <div className="custom-dropdown" ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
          <button
            id="values"
            type="button"
            className="custom-dropdown-btn"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            Values<span className="custom-dropdown-chevron">&#x25BC;</span>
          </button>
          {isOpen && (
            <div
              className="custom-dropdown-content"
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                zIndex: 20,
                minWidth: '160px',
                background: '#fff',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
                padding: '4px 0',
              }}
            >
              {formValues?.map((category, index) => (
                <div key={index} className="custom-dropdown-category">
                  <span
                    className="custom-category-label"
                    id="category-values"
                    style={{ display: 'block', padding: '6px 12px', cursor: 'pointer' }}
                    onClick={() => {
                      if (!category.subOptions?.length) {
                        handleChangeValues(category.value);
                      } else {
                        toggleSubOptions(index); // Toggle the sub-options on click
                      }
                    }}
                  >
                    {category.label}
                    {category.subOptions?.length > 0 && <span className="custom-sub-chevron">&#x25BC;</span>}
                  </span>
                  {category.subOptions?.length > 0 && openCategoryIndex === index && (
                    <div className="custom-dropdown-subcontent">
                      {category.subOptions.map(
                        (option, subIndex) =>
                          option.label !== 'Escrow' && (
                            <div
                              key={subIndex}
                              className="custom-dropdown-item"
                              id="subcategory-values"
                              style={{ display: 'block', padding: '6px 12px 6px 24px', cursor: 'pointer' }}
                              onClick={() => handleChangeValues(option.value)} // Handle click for sub-options
                            >
                              {option.label}
                            </div>
                          )
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValuesDropdown;
